import React from "react";
import Text from "@/bit/components/next13.components.text";
import Button from "@/bit/components/next13.components.button";

const TextCard = (props) => {
  return (
    <div className="text-card" data-cy="Text Card">
      {props["Text-1"] && (
        <Text {...props["Text-1"]} cyData="Text Card Title" />
      )}
      {props["Text-2"] && (
        <Text {...props["Text-2"]} cyData="Text Card Description" />
      )}
      {props["Button-1"] && (
        <Button
          {...props["Button-1"]}
          align="left"
          width="small"
          cyData="Text Card Button"
          taggingInfo={{
            componentName: "tv-module-text-card",
            componentVariation: "all",
            componentContent: props["Button-1"].label || "",
            componentProduct: (props["Text-1"] && props["Text-1"].text) || "",
            eventType: "click",
          }}
        />
      )}
    </div>
  );
};

export default TextCard;
